// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.automation_tab-button__g7F4O {
    background-color: #FFFFFF;
    color: #5D8EA4;
    width: 126px;
    height: 34px;
    font-size: 14px;
    border-radius: 5px;
    border: none;
    margin-right: 5px;
}

.automation_add-layer-button__\\+SL9e {
    border: 1px solid #0095FF;
    color: #0095FF;
    background: none;
    width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450
}

.automation_tab-button-active__lcTMc {
    background-color: #0095FF;
    color: #FFFFFF;
}

.automation_tab-content-container__eLcI1 {
    margin-top: 20px;
    width: 100%
}

.automation_form-textfield__YDetz {
    margin-bottom: 10px
}

.automation_server-content__VbNCi {
    padding: 30px;
    background-color: var(--color-content);
    color: var(--color-main-typography);

    width: 100%;
    height: 100vh;
}

.automation_server-tabs-background__asfGx {
    width: 100%;
    height: 100%;
    background-color: var(--color-content-sidebar);
    padding: 5px;
    border-radius: 5px;;
}

.automation_server-content-info-url-container__THn6s {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    margin-top: 20px
}

.automation_server-content-info-url-container-item__k1SlY {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    width: 183px;
}

.automation_server-settings-button__BdrpB {
    border: 1px solid #0095FF;
    color: #0095FF;
    background: none;
    width: 101px;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450
}

.automation_server-settings-secondary__7je0G {
    font-size: 10px;
    font-weight: 450;
    color: #8E99A0
}

.automation_server-settings-highlighted__VKhyy {
    font-size: 12px;
    font-weight: 450;
    color: #0095FF;
    text-decoration: underline;
}

.automation_servers-info-table__ot74n {
    border-collapse: collapse;
    width: 90%;
    margin-top: 10px;
}

.automation_servers-info-row__iMABK {
    border: none;
    height: 34px;
    text-align: left;
    font-size: 14px;
    font-weight: 450;
    padding: 5px;
    color: var(--color-secondary-typography);
}

.automation_servers-info-row__iMABK:nth-child(odd) {
    background-color: var(--color-content-sidebar);
}

.automation_mainWrapper__B0FjQ {
    flex: 1 1;
    height: 100vh;
    display: flex;
    align-items: flex-start;
}

.automation_rightBlock__LUIy\\+ {
    flex: 1 1;
    background: var(--color-content);
    height: 100vh;
    padding: 30px;
    color: var(--color-main-typography)
}

.automation_search-controls-container__oGh6F {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0;
}

.automation_search-field-container__pQS8v {
    display: flex;
    flex: 16 1;
}

.automation_search-filter-container__qte0F {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 3 1;
}

.automation_content-heading__dAh\\+v {
    margin-bottom: 40px;
    font-weight: 700;
    font-size: 20px;
}

.automation_content-container__S6nkS {
    padding: 0;
}

.automation_search-controls__G9hkM {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}

.automation_search-container__DkOcl {
    width: 444px;
}

@media screen and (max-width: 1000px) {
    .automation_server-content-info-url-container__THn6s {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 5px;
        margin-top: 20px
    }

    .automation_mainWrapper__B0FjQ {
        width: 100%;
    }

    .automation_rightBlock__LUIy\\+ {
        background: var(--color-content);
        height: 100vh;
        padding: 30px;
        width: 100%;
        padding: 0;
    }
    .automation_content-container__S6nkS {
        padding: 30px;
    }

    .automation_content-heading-container__gPf3o {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/automation/automation.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mCAAmC;;IAEnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;QAC3B,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,aAAa;QACb,WAAW;QACX,UAAU;IACd;IACA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ","sourcesContent":[".tab-button {\n    background-color: #FFFFFF;\n    color: #5D8EA4;\n    width: 126px;\n    height: 34px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: none;\n    margin-right: 5px;\n}\n\n.add-layer-button {\n    border: 1px solid #0095FF;\n    color: #0095FF;\n    background: none;\n    width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450\n}\n\n.tab-button-active {\n    background-color: #0095FF;\n    color: #FFFFFF;\n}\n\n.tab-content-container {\n    margin-top: 20px;\n    width: 100%\n}\n\n.form-textfield {\n    margin-bottom: 10px\n}\n\n.server-content {\n    padding: 30px;\n    background-color: var(--color-content);\n    color: var(--color-main-typography);\n\n    width: 100%;\n    height: 100vh;\n}\n\n.server-tabs-background {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-content-sidebar);\n    padding: 5px;\n    border-radius: 5px;;\n}\n\n.server-content-info-url-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 5px;\n    margin-top: 20px\n}\n\n.server-content-info-url-container-item {\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    justify-content: flex-start;\n    width: 183px;\n}\n\n.server-settings-button {\n    border: 1px solid #0095FF;\n    color: #0095FF;\n    background: none;\n    width: 101px;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450\n}\n\n.server-settings-secondary {\n    font-size: 10px;\n    font-weight: 450;\n    color: #8E99A0\n}\n\n.server-settings-highlighted {\n    font-size: 12px;\n    font-weight: 450;\n    color: #0095FF;\n    text-decoration: underline;\n}\n\n.servers-info-table {\n    border-collapse: collapse;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.servers-info-row {\n    border: none;\n    height: 34px;\n    text-align: left;\n    font-size: 14px;\n    font-weight: 450;\n    padding: 5px;\n    color: var(--color-secondary-typography);\n}\n\n.servers-info-row:nth-child(odd) {\n    background-color: var(--color-content-sidebar);\n}\n\n.mainWrapper {\n    flex: 1;\n    height: 100vh;\n    display: flex;\n    align-items: flex-start;\n}\n\n.rightBlock {\n    flex: 1;\n    background: var(--color-content);\n    height: 100vh;\n    padding: 30px;\n    color: var(--color-main-typography)\n}\n\n.search-controls-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    padding: 0;\n}\n\n.search-field-container {\n    display: flex;\n    flex: 16;\n}\n\n.search-filter-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 3;\n}\n\n.content-heading {\n    margin-bottom: 40px;\n    font-weight: 700;\n    font-size: 20px;\n}\n\n.content-container {\n    padding: 0;\n}\n\n.search-controls {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n.search-container {\n    width: 444px;\n}\n\n@media screen and (max-width: 1000px) {\n    .server-content-info-url-container {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 5px;\n        margin-top: 20px\n    }\n\n    .mainWrapper {\n        width: 100%;\n    }\n\n    .rightBlock {\n        background: var(--color-content);\n        height: 100vh;\n        padding: 30px;\n        width: 100%;\n        padding: 0;\n    }\n    .content-container {\n        padding: 30px;\n    }\n\n    .content-heading-container {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-button": `automation_tab-button__g7F4O`,
	"add-layer-button": `automation_add-layer-button__+SL9e`,
	"tab-button-active": `automation_tab-button-active__lcTMc`,
	"tab-content-container": `automation_tab-content-container__eLcI1`,
	"form-textfield": `automation_form-textfield__YDetz`,
	"server-content": `automation_server-content__VbNCi`,
	"server-tabs-background": `automation_server-tabs-background__asfGx`,
	"server-content-info-url-container": `automation_server-content-info-url-container__THn6s`,
	"server-content-info-url-container-item": `automation_server-content-info-url-container-item__k1SlY`,
	"server-settings-button": `automation_server-settings-button__BdrpB`,
	"server-settings-secondary": `automation_server-settings-secondary__7je0G`,
	"server-settings-highlighted": `automation_server-settings-highlighted__VKhyy`,
	"servers-info-table": `automation_servers-info-table__ot74n`,
	"servers-info-row": `automation_servers-info-row__iMABK`,
	"mainWrapper": `automation_mainWrapper__B0FjQ`,
	"rightBlock": `automation_rightBlock__LUIy+`,
	"search-controls-container": `automation_search-controls-container__oGh6F`,
	"search-field-container": `automation_search-field-container__pQS8v`,
	"search-filter-container": `automation_search-filter-container__qte0F`,
	"content-heading": `automation_content-heading__dAh+v`,
	"content-container": `automation_content-container__S6nkS`,
	"search-controls": `automation_search-controls__G9hkM`,
	"search-container": `automation_search-container__DkOcl`,
	"content-heading-container": `automation_content-heading-container__gPf3o`
};
export default ___CSS_LOADER_EXPORT___;
